frappe.ready(function () {
	var isAllProductsPage = window.location && window.location.pathname === "/all-products";
	var isItemGroupListing = Boolean(document.querySelector('.item-group-content[data-item-group]'));
	var hasListingRoot = Boolean(document.getElementById('product-listing'));
	if (!isAllProductsPage && !isItemGroupListing && !hasListingRoot) {
		return;
	}

  var discountsCache = {};
  var inflightRequest = false;

  function getCardItemCode(card) {
    if (!card) return null;
    return card.getAttribute('data-item-code') ||
      (card.querySelector('[data-item-code]') && card.querySelector('[data-item-code]').getAttribute('data-item-code')) ||
      null;
  }

  function ensureDiscountLabel(card, discount) {
    if (!card || discount == null || discount === '') return;

    var cardBody = card.querySelector('.card-body') || card;
    if (!cardBody) return;

    var numericDiscount = Number(discount);
    if (!Number.isFinite(numericDiscount) || numericDiscount <= 0) return;

    var existing = cardBody.querySelector('.customer-discount-info');
    if (existing) {
      existing.textContent = numericDiscount + '% Consumer Offer';
      return;
    }

    var ribbon = document.createElement('div');
    ribbon.className = 'customer-discount-info';
    ribbon.textContent = numericDiscount + '% Consumer Offer';

    var priceEl = cardBody.querySelector('.product-price');
    if (priceEl && priceEl.parentNode) {
      if (priceEl.nextSibling) {
        priceEl.parentNode.insertBefore(ribbon, priceEl.nextSibling);
      } else {
        priceEl.parentNode.appendChild(ribbon);
      }
    } else {
      cardBody.insertBefore(ribbon, cardBody.firstChild);
    }
  }

  function injectConsumerDiscounts() {
    var listing = document.getElementById('product-listing');
    if (!listing) return;

    var cards = listing.querySelectorAll('.item-card');
    var unprocessedCards = Array.prototype.filter.call(cards, function (card) {
      return !card.hasAttribute('data-consumer-discount-checked');
    });

    if (!unprocessedCards.length) return;

    var codesSet = new Set();
    unprocessedCards.forEach(function (card) {
      var code = getCardItemCode(card);
      if (code) codesSet.add(code);
    });

    var itemCodes = Array.from(codesSet);
    if (!itemCodes.length) return;

    function applyDiscounts() {
      unprocessedCards.forEach(function (card) {
        var code = getCardItemCode(card);
        if (!code) return;

        card.setAttribute('data-consumer-discount-checked', '1');
        ensureDiscountLabel(card, discountsCache[code]);
      });
    }

    var missingCodes = itemCodes.filter(function (c) { return !(c in discountsCache); });
    if (!missingCodes.length) {
      applyDiscounts();
      return;
    }

    if (inflightRequest) return;
    inflightRequest = true;

    frappe.call({
      method: 'raftor_webhq.catalog.api.get_consumer_discounts',
      args: { item_codes: missingCodes },
      callback: function (r) {
        inflightRequest = false;
        if (r && r.message) {
          Object.keys(r.message).forEach(function (code) {
            discountsCache[code] = r.message[code];
          });
        }
        missingCodes.forEach(function (code) {
          if (!(code in discountsCache)) discountsCache[code] = null;
        });
        applyDiscounts();
      },
      error: function () {
        inflightRequest = false;
      }
    });
  }

  setTimeout(injectConsumerDiscounts, 650);
  document.addEventListener('products-loaded', function () {
    setTimeout(injectConsumerDiscounts, 50);
  });

  var listing = document.getElementById('product-listing');
  if (listing) {
    var timer = null;
    window.webhqDom.onAdded(function (roots) {
      var touchesListing = roots.some(function (r) {
        return r === listing || listing.contains(r) || r.contains(listing);
      });
      if (!touchesListing) return;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(injectConsumerDiscounts, 400);
    });
  }
});
